/** Shared Actions / Process chrome — keep payroll, attendance, and modals aligned. */

export const ACTION_FRAME =
  "flex min-h-0 flex-1 overflow-hidden rounded-lg border border-[hsl(var(--ds-primary)/0.25)] bg-white dark:bg-[hsl(var(--ds-surface))]";

export const ACTION_RAIL =
  "flex w-[15rem] shrink-0 flex-col border-r border-[hsl(var(--ds-primary)/0.2)] bg-white dark:bg-[hsl(var(--ds-surface))]";

export const ACTION_RAIL_LABEL =
  "px-2.5 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-[hsl(var(--ds-primary))]";

export const ACTION_RAIL_ITEM =
  "group flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-left transition-colors";

export const ACTION_RAIL_ICON_BOX =
  "pace-action-rail-icon inline-flex h-6 w-6 shrink-0 items-center justify-center overflow-hidden rounded-md";

export const ACTION_RAIL_ICON_SIZE = 20;

export const ACTION_RAIL_TEXT =
  "min-w-0 flex-1 whitespace-nowrap text-[11px] font-medium leading-tight tracking-tight";

export const ACTION_CARD =
  "flex min-h-[26rem] flex-col overflow-hidden rounded-lg border-2 border-[hsl(var(--ds-primary)/0.35)] bg-white shadow-sm dark:bg-[hsl(var(--ds-surface))]";

export const ACTION_CARD_FOOTER =
  "relative z-[30] flex shrink-0 flex-wrap items-center justify-between gap-2 rounded-b-lg border-t border-[hsl(var(--ds-primary)/0.2)] bg-white px-5 py-3.5 dark:bg-[hsl(var(--ds-surface))]";

export const ACTION_SELECT_WELL =
  "relative z-10 min-h-[3.25rem] rounded-[11px] border border-[hsl(var(--hrms-line))] bg-[hsl(var(--hrms-bg))] px-3 py-2.5";

export const ACTION_DROPDOWN_RESERVE = "min-h-[11rem] shrink-0";

export const PROCESS_FRAME = ACTION_FRAME;

export const PROCESS_RAIL =
  "flex w-[13.5rem] shrink-0 flex-col border-r border-[hsl(var(--ds-primary)/0.2)] bg-white dark:bg-[hsl(var(--ds-surface))]";

export const PROCESS_MAIN =
  "flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg border-2 border-[hsl(var(--ds-primary)/0.35)] bg-white p-3.5 dark:bg-[hsl(var(--ds-surface))]";

export const ACTION_MODAL_OVERLAY =
  "fixed inset-0 z-[10020] flex items-center justify-center bg-black/40 p-4";

export const ACTION_MODAL_SHELL =
  "flex max-h-[92vh] w-[min(100%,720px)] flex-col overflow-hidden rounded-lg border-2 border-[hsl(var(--ds-primary)/0.35)] bg-white shadow-[var(--ds-shadow-panel)] dark:bg-[hsl(var(--ds-surface))] text-[hsl(var(--ds-fg))]";

export const ACTION_MODAL_HEADER =
  "flex items-start justify-between gap-3 border-b border-[hsl(var(--ds-primary)/0.15)] px-5 py-4";

export const ACTION_MODAL_BODY = "flex-1 overflow-y-auto px-5 py-4";

export const ACTION_MODAL_FOOTER =
  "flex shrink-0 flex-wrap items-center justify-end gap-2 border-t border-[hsl(var(--ds-primary)/0.15)] bg-[hsl(var(--ds-primary)/0.02)] px-5 py-3.5";
